import React from 'react';
import { CheckmarkFilled20, ErrorFilled20 } from '@carbon/icons-react';
import { useIntl } from 'react-intl';
import messages from 'src/apps/envizi-price-estimator/locales/messages';

type selectionProps = {
  answer: string;
  id?: string;
  result: valueProps[];
  state: string;
};

type valueProps = {
  id: string;
  answer: string;
  state: string;
};

const Selection = ({ answer, id, result, state }: selectionProps) => {
  const intl = useIntl();
  const getState = (id: string, ans: valueProps[]) =>
    ans
      .filter((item: valueProps) => item.id === id)
      .map((item: valueProps) => item.state)
      .toString();

  const getAnswer = (id: string, ans: valueProps[]) =>
    ans
      .filter((item: valueProps) => item.id === id)
      .map((item: valueProps) => item.answer)
      .toString();

  const translateState = (state: string) => {
    let translatedStateStr;
    switch (state) {
      case 'Industry':
        translatedStateStr = intl.formatMessage(messages.q1_state);
        break;
      case 'Facilities / Locations':
        translatedStateStr = intl.formatMessage(messages.q2_state);
        break;
      case 'Greenhouse gas reports':
        translatedStateStr = intl.formatMessage(messages.q3_state);
        break;
      case 'Scope 1 and 2 emissions':
        translatedStateStr = intl.formatMessage(messages.q3_scope1n2_state);
        break;
      case 'Scope 3 emissions':
        translatedStateStr = intl.formatMessage(messages.q3_scope3_state);
        break;
      case 'Compliance':
        translatedStateStr = intl.formatMessage(messages.q3_compliance_state);
        break;
      case 'Value chain insights':
        translatedStateStr = intl.formatMessage(messages.q3_valueChain_state);
        break;
      case 'ESG disclosures':
        translatedStateStr = intl.formatMessage(messages.q4_state);
        break;
    }
    return translatedStateStr;
  };

  return id ? (
    <li className="selection-item sub-answer" key={id}>
      <div className="margin">
        <span className="selection-state">
          {translateState(getState(id, result))}:
        </span>
        <span className="bold_text answer">{getAnswer(id, result)}</span>
        {answer !== intl.formatMessage(messages.no) ? (
          <CheckmarkFilled20 className="icon-style" fill="#24A148" />
        ) : (
          <ErrorFilled20 className="icon-style" fill="#8d8d8d" />
        )}
      </div>
    </li>
  ) : (
    <li className="selection-item" key={id}>
      <div className="margin">
        <span className="selection-state">{translateState(state)}:</span>
        <span className="bold_text answer">{answer}</span>
        {answer !== intl.formatMessage(messages.no) ? (
          <CheckmarkFilled20 className="icon-style" fill="#24A148" />
        ) : (
          <ErrorFilled20 className="icon-style" fill="#8d8d8d" />
        )}
      </div>
    </li>
  );
};

export default Selection;
